<span [class]="statusClass">
  {{ 'VALUE day(s) ' + info | translate: { value: noOfDays } }}
  <mat-progress-bar mode="determinate" [value]="status"></mat-progress-bar>
</span>
